import { push } from 'connected-react-router';
import { Epic } from 'redux-observable';
import { MonoTypeOperatorFunction, OperatorFunction } from 'rxjs';
import { endWith, filter, startWith } from 'rxjs/operators';
import { Action, ActionCreator, AnyAction } from 'typescript-fsa';

import { begin, end, IndicatorPayload } from 'src/actions/indicator';
import { IRootState } from 'src/reducers';

/**
 * 指定したActionCreatorによるActionのみにフィルタするOperator
 * @param creators 残したいActionCreator(複数可)
 */
export const ofAction = <Payload extends {} | void>(
	...creators: Array<ActionCreator<Payload>>
): MonoTypeOperatorFunction<Action<Payload>> =>
	filter(x => creators.some(c => c.type === x.type));

/**
 * Epicの依存オブジェクト
 */
export const dependencies = {
	/**
	 * Routerへのpush
	 */
	push,
};

/**
 * Epicの型: dependenciesを指定
 */
export type EpicType = Epic<
	AnyAction,
	AnyAction,
	IRootState,
	typeof dependencies
>;

/**
 * このObservableの前後でIndicatorのBEGIN及びENDを発行する
 * @param key 有効化用キー
 */
export const withIndicator = <T>(
	key: string
): OperatorFunction<Action<T>, Action<T | IndicatorPayload>> => action$ =>
	action$.pipe(
		startWith(begin({ key })),
		endWith(end({ key }))
	);



// WEBPACK FOOTER //
// ./src/epics/common.ts